import { IConsuptionOptions } from '@/app/core/interfaces/consumption.interface';
import { IApplyFineAdjustment } from '@/app/core/interfaces/apply-fine-adjustment.interface';

export class GetFineAdjustmentAction {
  static readonly type = '[FineAdjustment] Get Fine Adjustment';
  constructor(public payload: IConsuptionOptions) {}
}

export class ApplyFineAdjustmentAction {
  static readonly type = '[FineAdjustment] Apply Fine Adjustment';
  constructor(public payload: IApplyFineAdjustment) {}
}

export class ClearFineAdjustmentValuesAction {
  static readonly type = '[FineAdjustment] Clear Fine Adjustment Values';
}

export class ResetClearingFlagAction {
  static readonly type = '[FineAdjustment] Reset Clearing Flag';
}
